import styled, { css } from 'styled-components';
import { skeleton } from './skeleton';

export const RowWrapper = styled.li(
  ({ theme }) => css`
    align-items: center;
    display: flex;

    border-bottom: ${theme.bo.thinWidth} solid ${theme.co.secondary90};
    min-width: 100%;
  `,
);

export const Word = styled.a<{ $isLoading?: boolean }>(
  ({ theme, $isLoading }) => css`
    ${$isLoading && skeleton}

    width: 50%;
    color: ${theme.co.secondary10};

    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    margin: ${theme.sz.s6} ${theme.sz.s4};

    text-align: start;
    text-decoration: ${$isLoading ? 'none' : 'underline'};
    text-decoration-color: ${theme.co.primary20};

    ${theme.typography.heading.desktop.xs};

    &:hover,
    &:focus {
      color: ${theme.co.secondary60};
      text-decoration: none;
    }

    &:active {
      color: ${theme.co.secondary40};
    }

    @media (max-width: ${theme.sz.md}) {
      ${theme.typography.heading.desktop.xxs};
    }
  `,
);

export const Translation = styled.span<{ $isLoading?: boolean }>(
  ({ theme, $isLoading }) => css`
    ${$isLoading && skeleton}

    width: 50%;
    color: ${theme.co.secondary50};

    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    text-align: start;
    margin: ${theme.sz.s6} ${theme.sz.s4};

    ${theme.typography.paragraph.l};
    @media (max-width: ${theme.sz.md}) {
      ${theme.typography.paragraph.base};
    }
  `,
);
